import { render } from "./CMSEditCard.vue?vue&type=template&id=0b1afc74"
import script from "./CMSEditCard.vue?vue&type=script&lang=js"
export * from "./CMSEditCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__